import { gql } from 'apollo-angular';
import { ContentGenerationOutputFragment } from '@modules/funnels/shared/graphql/fragments/content-generation-output.fragment';

export const GenerateImagesForFunnelDocument = gql`
  mutation generateImagesForFunnel($input: GenerateContentInputGraphql!) {
    generateImagesForFunnel(input: $input) {
      ...ContentGenerationOutput
    }
  }
  ${ContentGenerationOutputFragment}
`;
